import React, { useState } from 'react';
import Select from 'react-select';
import styles from '../css/styles.module.css'
import { selectStyle } from './selectStyle';

export default function AddForm(props) {
    const [contact, setContact] = useState(() => {
        return({
            name: "",
            customer: "",
            email: "",
            phone: "",
            position: ""
        });
    });

    //handle text change for input field
    function handleChange(e) {
        setContact({
            ...contact,
            [e.target.name]: e.target.value
        });
    }

    //handle dropdow select change
    function handleSelectChange(selected, actionMeta){
        setContact({
            ...contact,
            [actionMeta.name]: selected.value
        });
    }

    return (
        <div className={styles.form}>
            <form onSubmit={() => { props.handleAddSubmit(contact) }}>
                <h1>Add contact</h1>
                <Select
                    name="customer"
                    styles={selectStyle}
                    isSearchable
                    placeholder="Customer"
                    options={props.customer}
                    onChange={(selected, actionMeta) => handleSelectChange(selected, actionMeta)}
                />
                <input type="text" name="name" placeholder="Name" onChange={handleChange} value={contact.name} required />
                <input type="email" name="email" placeholder="Email" onChange={handleChange} value={contact.email} />
                <input type="text" name="phone" placeholder="Phone Number" onChange={handleChange} value={contact.phone} />
                <input type="text" name="position" placeholder="Position" onChange={handleChange} value={contact.position} />
                <button type="submit">Add</button>
            </form>
            <button className={styles.cancelButton} onClick={() => props.handleCancelClick()}>Cancel</button>
        </div>
    );
}